import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import Auth from 'j-toker';
import { Helmet } from 'react-helmet';
import { ContentProvider } from '@yuhu-inc/yuhui';

import 'App.css';
import Confetti from 'react-dom-confetti';

import { SideBar, NavLinkItem, NavGroupItem, MobileMenu } from 'navigation/sidebar/SideBar';
import NavBar from 'navigation/NavBar';
import SignatureNavBar from 'components/byesign/signatureNavBar';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import * as authentication from 'actions/authenticationActions';
import * as notification from 'actions/notificationActions';
import * as navigation from 'actions/navigationActions';
import * as screenDimensionsActions from 'actions/screenDimensionsActions';
import * as userTypesActions from 'actions/userTypesActions';

import LoadingBar from 'react-redux-loading-bar';
import Sidebar from 'react-sidebar';
import MediaQuery from 'react-responsive';
import NotificationSystem from 'react-notification-system';
import Measure from 'react-measure';
import { BounceLoader } from 'halogenium';

import PayWall from 'navigation/PayWall';
import PasswordExpiring from 'navigation/PasswordExpiring';
import LoginDialog from 'navigation/LoginDialog';

import {
  MdAttachMoney as PaymentIcon,
  MdLocalAtm as FeesIcon,
  MdAccountBalanceWallet as PaymentsIcon,
  MdDashboard as HomeIcon,
  MdBuild as MaintenanceIcon,
  MdEventAvailable as CalendarIcon,
  MdAccountBox as LeadsIcon,
  MdPeople as LeadGroupIcon,
  MdLightbulbOutline as InsightsIcon,
  MdLocationCity as PropertiesIcon,
  MdSupervisorAccount as AgentIcon,
  MdDescription as ApplicationIcon,
  MdViewList as RentRollIcon,
  MdTimeline as ReportIcon,
  MdAssignmentTurnedIn as InspectionIcon,
  MdCheck as VerifiedIcon,
  MdRemoveCircle as UnverifiedIcon,
  MdDescription as TicketIcon,
  MdShoppingCart as VendorIcon,
  MdSwapHoriz as APIDashboardIcon,
  MdLibraryBooks as APIDocumentIcon,
  MdSettingsApplications as APISettingsIcon,
  MdEventSeat as AmenitiesIcon,
  MdLoyalty as SurveysIcon,
  MdFavoriteBorder as CommunityIcon,
  MdGroupAdd as ReferralIcon,
  MdLocalShipping as ParcelsIcon,
  MdPersonAdd as VisitorsIcon,
  MdAnnouncement as NoticesIcon,
  MdKitchen as AssetIcon,
  MdList as LogIcon,
  MdContentPaste as ClipboardIcon,
  MdFileCopy as TemplateIcon,
  MdNotificationsActive as EscalationIcon,
  MdConstruction as ApplicationBuilderIcon,
  MdPolicy as PolicyIcon,
} from 'react-icons/md';

import {
  FaEnvelope as EnvelopeIcon,
  FaCalendar as ShowingsIcon,
  FaTags as PromotionsIcon,
} from 'react-icons/fa';

import RulesIcon from '@material-ui/icons/Code';
import SelfServiceKioskIcon from '@material-ui/icons/LocationOn';
import MaintenanceInsightsIcon from '@material-ui/icons/PieChart';
import { localize } from 'react-localize-redux';

import LandlordLogo from './components/shared/LandlordLogo';
import { apiGet } from './helpers/ApiHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { compact } from 'helpers/utilities';
import { customSquareImages } from 'helpers/LogoHelper';
import {
  getCompanyName,
  hostIsBgoResidents,
  hostIsBoardwalk,
  hostIsHollyburn,
} from 'helpers/CurrentWindowLocation';
import { getTranslatedString, getCurrentLocale, contentNodes } from 'helpers/i18n';

import IncompatibleBrowser from './components/shared/IncompatibleBrowser';

import { isIE } from 'react-device-detect';
import styled from 'styled-components';
import { featureEnabled } from 'helpers/ToggleBot';

const VALIDATE_TOKEN_POLL_IN_MS = 5 * 60 * 1000; // 5 mins

const content = {
  contentNodes,
  theme: {
    colors: {
      primary: {
        light: colors.LIGHT_BLUE_GREY,
        dark: colors.ULTRAMARINE_BLUE,
      },
    },
  },
};

const lang = getCurrentLocale();

const StyledDiv = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  background-color: ${(props) => (props.showBlackBorder ? '#000' : 'rgb(234, 236, 241)')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledDivBlackBorder = styled.div`
  padding: 20px;
  background-color: #000;
  border-radius: 25px;
`;

export default localize()(
  connect(
    (store) => {
      return {
        active: store.userTypes.active,
        passwordExpirationDate: store.userTypes.passwordExpirationDate,
        changePasswordURL: store.userTypes.changePasswordURL,
        showLoginForm: store.authentication.showLoginForm,
        showPage: store.authentication.showPage,
        showLoginDialog: store.authentication.showLoginDialog,
        shouldShowNonAuthPage: store.authentication.shouldShowNonAuthPage,
        updateSuccessNotice: store.notifications.updateSuccessNotice,
        updateFailureNotice: store.notifications.updateFailureNotice,
        message: store.notifications.message,
        showSignDocument: store.authentication.showSignaturePage,
        isLandlord: store.userTypes.isLandlord,
        userType: store.userTypes.loginAuth,
        showLoader: store.notifications.showLoader,
        verbiage: store.notifications.verbiage,
        maintenanceWorker: store.userTypes.isMaintenance,
        agent: store.userTypes.isLandlord,
        selectedRoute: store.navigation.selectedRoute,
        thirdPartyManager: store.userTypes.isThirdPartyManager,
        explosionCelebration: store.notifications.explosionCelebration,
        expiringDialogOpen: store.userTypes.expiringDialogOpen,
        showMessaging: store.userTypes.showMessaging,
        landlordLogoThumbUrl: store.userTypes.landlordLogoThumbUrl,
        helpDocuments: store.userTypes.helpDocuments,
        currentLanguage: store.locale.currentLanguage,
        translations: store.locale.translations,
      };
    },
    {
      logUserOut: authentication.logUserOut,
      hideSuccess: notification.hideSuccess,
      hideFailure: notification.hideFailure,
      showFailure: notification.showFailure,
      changeSignaturePageDimensions: screenDimensionsActions.changeDimensions,
      selectRoute: navigation.selectRoute,
      setUserAsLandlord: userTypesActions.setUserAsLandlord,
      hideExpiringPasswordDialog: userTypesActions.hideExpiringPasswordDialog,
    }
  )(
    class App extends Component {
      constructor(props) {
        super(props);
        this.state = {
          sidebarOpen: false,
          sidebarDocked: true,
          sidebarIsOpen: true,
        };
        this.notificationSystem = null;
      }

      componentDidMount() {
        if (isIE) return;

        const initialised_width = this.refs.appContainer.offsetWidth;
        if (initialised_width < 750) {
          this.setState({ sidebarDocked: false, sidebarIsOpen: false });
        }
        this.notificationSystem = this.refs.notificationSystem;
        apiGet(Auth.getApiUrl() + '/user/activity_poll').then((response) => {
          if (!response.active) {
            this.props.logUserOut();
            if (browserHistory.getCurrentLocation().pathname.includes('/maintenance/')) {
              browserHistory.push('/maintenance');
            } else {
              browserHistory.push('/companies');
            }
            window.location.reload();
          }
        });
        this.validateTokenPolling = this.validateToken();
      }

      validateToken = () => {
        return setInterval(() => {
          if (
            browserHistory.getCurrentLocation().pathname !== '/companies' &&
            browserHistory.getCurrentLocation().pathname !== '/maintenance'
          ) {
            fetch(Auth.getApiUrl() + '/health/status', {
              method: 'GET',
            })
              .then((response) => {
                if (response.status === 200) {
                  apiGet(Auth.getApiUrl() + '/user/activity_poll').then((response) => {
                    if (!response.active) {
                      this.props.logUserOut();
                      if (browserHistory.getCurrentLocation().pathname.includes('/maintenance/')) {
                        browserHistory.push('/maintenance');
                      } else {
                        browserHistory.push('/companies');
                      }
                      window.location.reload();
                    }
                  });
                  apiGet(Auth.getApiUrl() + '/user/permissions')
                    .then((user) => {
                      // eslint-disable-next-line
                      if (browserHistory.getCurrentLocation().pathname.includes('/maintenance/'))
                        return;

                      localStorage.setItem('currentConfigName', '"landlord"');
                      this.props.setUserAsLandlord(user);
                    })
                    .catch((error) => {
                      this.props.showFailure(error);
                      console.warn(error);
                    });
                }
              })
              .catch(() => {
                this.props.logOutLandlordUser({ showDialog: true });
              });
          }
        }, VALIDATE_TOKEN_POLL_IN_MS);
      };

      componentWillUnmount() {
        if (isIE) return;

        clearInterval(this.validateTokenPolling);
      }

      translateMessage = (message) => {
        const { currentLanguage, translations } = this.props;
        if (message in translations.global[currentLanguage]) {
          return translations.global[currentLanguage][message];
        } else {
          return message;
        }
      };

      componentDidUpdate() {
        if (isIE) return;

        if (this.props.updateSuccessNotice) {
          this.notificationSystem.addNotification({
            message: '',
            level: 'success',
            position: 'tr',
            autoDismiss: 5,
            children: (
              <div style={{ fontSize: '17px' }}>
                <span>
                  <VerifiedIcon style={{ verticalAlign: 'text-top' }} />
                  &nbsp;&nbsp;
                  {this.props.message
                    ? this.translateMessage(this.props.message)
                    : getTranslatedString('successfullyUpdated')}
                </span>
              </div>
            ),
          });
          this.props.hideSuccess();
        } else if (this.props.updateFailureNotice) {
          this.notificationSystem.addNotification({
            message: '',
            level: 'error',
            position: 'tr',
            autoDismiss: 5,
            children: (
              <div style={{ fontSize: '17px' }}>
                <span>
                  <UnverifiedIcon style={{ verticalAlign: 'text-top' }} />
                  &nbsp;&nbsp;
                  {this.props.message
                    ? this.translateMessage(this.props.message)
                    : getTranslatedString('unknownError')}
                </span>
              </div>
            ),
          });
          this.props.hideFailure();
        }
      }

      addNotification = () => {
        this.notificationSystem.addNotification(this.props.notificationBody);
      };

      onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
      }

      dockSidebar(dock, open_or_closed) {
        this.setState({ sidebarDocked: dock, sidebarIsOpen: open_or_closed });
      }

      _onResize = (width) => {
        if (width > 1024) {
          this.setState({ sidebarDocked: true, sidebarIsOpen: true });
        } else {
          this.setState({ sidebarDocked: false, sidebarIsOpen: false });
        }
      };

      UNSAFE_componentWillReceiveProps(nextProps) {
        if (isIE) return;

        this.setState({
          children: nextProps.children,
        });
      }

      handleChange = (event, index, value) => this.props.selectRoute({ value });

      render() {
        if (isIE) {
          return <IncompatibleBrowser />;
        }

        let customSquareImage = null;
        if (hostIsHollyburn()) {
          customSquareImage = customSquareImages.HOLLYBURN;
        }

        // TODO: temporarily adding this as we do not have all splash screens
        const newPaths = [
          '/companies',
          '/companies/agent_password_reset',
          '/companies/agent_change_password_from_email',
          '/tenant_change_password_from_email',
          '/maintenance/maintenance_change_password_from_email',
          '/maintenance',
          '/maintenance/maintenance_password_reset',
        ];
        const path = browserHistory.getCurrentLocation().pathname;
        const isNewPath = newPaths.includes(path) && hostIsBgoResidents();

        const showSplashScreenTemplate =
          this.props.showLoginForm || this.props.shouldShowNonAuthPage;
        const showSignDocument = this.props.showSignDocument;

        const showSplashWithBackground =
          !this.props.showLoader &&
          showSplashScreenTemplate &&
          newPaths.includes(path) &&
          hostIsBgoResidents();
        const showSplashBlackBorder =
          showSplashScreenTemplate && newPaths.includes(path) && hostIsBoardwalk();

        const showSplashCentered =
          !showSplashWithBackground && !showSplashBlackBorder && showSplashScreenTemplate;

        const translateText = (text) => this.props.translate(text).props.children;
        const confettiConfig = {
          angle: 90,
          spread: 78,
          startVelocity: 20,
          elementCount: 146,
          decay: 0.96,
        };

        let communityLinks = [
          {
            link_to: '/companies/notices',
            primaryText: translateText('landlordPortal.sideBar.notices'),
            leftIcon: <NoticesIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/amenities',
            primaryText: translateText('landlordPortal.sideBar.amenities'),
            leftIcon: <AmenitiesIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/events',
            primaryText: translateText('landlordPortal.sideBar.calendar'),
            leftIcon: <CalendarIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/parcels',
            primaryText: translateText('landlordPortal.sideBar.parcelDelivery'),
            leftIcon: <ParcelsIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/promotions',
            primaryText: translateText('landlordPortal.sideBar.promotions'),
            leftIcon: <PromotionsIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/surveys',
            primaryText: translateText('landlordPortal.sideBar.surveys'),
            leftIcon: <SurveysIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/visitors',
            primaryText: translateText('landlordPortal.sideBar.visitors'),
            leftIcon: <VisitorsIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/logs',
            primaryText: translateText('landlordPortal.sideBar.logs'),
            leftIcon: <LogIcon className="transactionIcon" />,
          },
        ];

        let insightsLinks = [
          {
            link_to: '/companies/reporting',
            primaryText: translateText('landlordPortal.sideBar.reporting'),
            leftIcon: <ReportIcon className="accountIcon" />,
          },
          {
            link_to: '/companies/rules',
            primaryText: translateText('landlordPortal.sideBar.rules'),
            leftIcon: <RulesIcon className="accountIcon" />,
          },
          {
            link_to: '/companies/maintenance_insights',
            primaryText: translateText('landlordPortal.sideBar.maintenance'),
            leftIcon: <MaintenanceInsightsIcon className="accountIcon" />,
          },
          {
            link_to: '/companies/insight_dashboards',
            primaryText: translateText('landlordPortal.sideBar.insightDashboards'),
            leftIcon: <MaintenanceInsightsIcon className="accountIcon" />,
          },
        ];

        const maintenanceLinks = [
          {
            link_to: '/companies/maintenance/tickets',
            primaryText: translateText('landlordPortal.sideBar.tickets'),
            leftIcon: <TicketIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/recurring_tickets',
            primaryText: translateText('landlordPortal.sideBar.ticketTemplates'),
            leftIcon: <TemplateIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/ticket_scheduler',
            primaryText: translateText('landlordPortal.sideBar.ticketScheduler'),
            leftIcon: <CalendarIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/assets',
            primaryText: translateText('landlordPortal.sideBar.assets'),
            leftIcon: <AssetIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/vendors',
            primaryText: translateText('landlordPortal.sideBar.vendors'),
            leftIcon: <VendorIcon className="accountIcon" />,
          },
          {
            link_to: '/companies/inspections',
            primaryText: translateText('landlordPortal.sideBar.inspections'),
            leftIcon: <InspectionIcon className="accountIcon" />,
          },
          {
            link_to: '/companies/inspection_templates',
            primaryText: translateText('landlordPortal.sideBar.inspectionTemplates'),
            leftIcon: <TemplateIcon className="accountIcon" style={{ margin: 14 }} />,
          },
          {
            link_to: '/companies/escalation',
            primaryText: translateText('landlordPortal.sideBar.escalation'),
            leftIcon: <EscalationIcon className="transactionIcon" />,
          },
        ];

        if (featureEnabled('purchase_order')) {
          const purchaseOrderLink = {
            link_to: '/companies/purchase_orders',
            primaryText: translateText('landlordPortal.purchaseOrders.purchaseOrders'),
            leftIcon: <VendorIcon className="accountIcon" />,
          };

          maintenanceLinks.splice(3, 0, purchaseOrderLink);
        }

        if (featureEnabled('ui.maintenance.new_tickets_ui')) {
          const maintenanceProjectsLink = {
            link_to: '/companies/maintenance/projects',
            primaryText: translateText('landlordPortal.maintenance.projects.maintenanceProjects'),
            leftIcon: <ClipboardIcon className="accountIcon" />,
          };
          maintenanceLinks.splice(4, 0, maintenanceProjectsLink);
        }

        const prospectsLinks = [
          {
            link_to: '/companies/prospects',
            primaryText: translateText('landlordPortal.sideBar.prospects'),
            leftIcon: <LeadsIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/showings',
            primaryText: translateText('landlordPortal.sideBar.showings'),
            leftIcon: <ShowingsIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/referrals',
            primaryText: translateText('landlordPortal.sideBar.referrals'),
            leftIcon: <ReferralIcon className="transactionIcon" />,
          },
          {
            link_to: '/companies/lead_managing',
            primaryText: 'Lead Managing',
            leftIcon: <LeadsIcon className="transactionIcon" />,
          },
        ];

        const apiDashboardLinks = [
          {
            link_to: '/companies/api_dashboard_documents',
            primaryText: translateText('landlordPortal.sideBar.documents'),
            leftIcon: <APIDocumentIcon className="accountIcon" />,
          },
          {
            link_to: '/companies/api_dashboard_settings',
            primaryText: translateText('landlordPortal.sideBar.settings'),
            leftIcon: <APISettingsIcon className="accountIcon" />,
          },
        ];

        const selfServiceKioskLinks = [
          {
            link_to: '/companies/calendar_kiosk',
            primaryText: translateText('landlordPortal.sideBar.eventsCalendar'),
            leftIcon: <CalendarIcon className="messageIcon" />,
          },
          {
            link_to: '/companies/parcels_kiosk',
            primaryText: translateText('landlordPortal.sideBar.parcelDelivery'),
            leftIcon: <ParcelsIcon className="messageIcon" />,
          },
          {
            link_to: '/companies/maintenance_tickets_kiosk',
            primaryText: translateText('landlordPortal.sideBar.tickets'),
            leftIcon: <TicketIcon className="messageIcon" />,
          },
        ];

        let showMessagingLink = this.props.showMessaging ? (
          <NavLinkItem
            to="/companies/messaging"
            key="/companies/messaging"
            primaryText={translateText('landlordPortal.sideBar.messaging')}
            leftIcon={<EnvelopeIcon className="messageIcon" />}
          />
        ) : null;

        let showCustomLeaseTemplate = featureEnabled('custom_lease_creator') ? (
          <NavLinkItem
            to="/companies/document_templates"
            key="/companies/document_templates"
            primaryText={translateText('landlordPortal.sideBar.documentTemplate')}
            leftIcon={<ApplicationIcon />}
          />
        ) : null;

        const templatesList = featureEnabled('application-management') ? (
          <NavLinkItem
            to="/companies/application_templates"
            key="/companies/application_templates"
            primaryText={translateText('landlordPortal.sideBar.applicationTemplate')}
            leftIcon={<ApplicationBuilderIcon />}
          />
        ) : null;

        const policiesLink = featureEnabled('application-management') ? (
          <NavLinkItem
            to="/companies/policies"
            key="/companies/policies"
            primaryText={translateText('landlordPortal.sideBar.policies')}
            leftIcon={<PolicyIcon />}
          />
        ) : null;

        const batchesLink = featureEnabled('yuhu_pay_v2') ? (
          <NavLinkItem
            to="/companies/batches"
            key="/companies/batches"
            primaryText={translateText('landlordPortal.sideBar.batches')}
            leftIcon={<PaymentIcon />}
          />
        ) : null;

        const paymentsLink = featureEnabled('internal_lease_charge_creation') ? (
          <NavLinkItem
            to="/companies/charges"
            key="/companies/charges"
            primaryText={translateText('landlordPortal.sideBar.charges')}
            leftIcon={<PaymentIcon />}
          />
        ) : null;

        const paymentsMenuVisible = featureEnabled('ui.fees') || featureEnabled('ui.incentives');
        const paymentsMenuLinks = [];
        if (featureEnabled('ui.fees')) {
          paymentsMenuLinks.push({
            link_to: '/companies/fees',
            primaryText: translateText('landlordPortal.sideBar.fees'),
            leftIcon: <FeesIcon className="accountIcon" />,
          });
        }
        if (featureEnabled('ui.incentives')) {
          paymentsMenuLinks.push({
            link_to: '/companies/incentives',
            primaryText: translateText('landlordPortal.sideBar.incentives'),
            leftIcon: <FeesIcon className="accountIcon" />,
          });
        }
        const paymentsMenu = paymentsMenuVisible ? (
          <NavGroupItem
            key="/companies/payments"
            primaryText={translateText('landlordPortal.sideBar.payments')}
            leftIcon={<PaymentsIcon />}
            links={paymentsMenuLinks}
          />
        ) : null;

        let NavigationItems = [
          <NavLinkItem
            to="/companies/dashboard"
            key="/companies/dashboard"
            primaryText={translateText('landlordPortal.sideBar.dashboard')}
            leftIcon={<HomeIcon />}
          />,

          <NavGroupItem
            key="/companies/insights"
            primaryText={translateText('landlordPortal.sideBar.insights')}
            leftIcon={<InsightsIcon />}
            links={insightsLinks}
          />,

          <NavGroupItem
            key="/companies/prospects"
            primaryText={translateText('landlordPortal.sideBar.prospects')}
            leftIcon={<LeadGroupIcon />}
            links={prospectsLinks}
          />,

          <NavLinkItem
            to="/companies/applications"
            key="/companies/applications"
            primaryText={translateText('landlordPortal.sideBar.applications')}
            leftIcon={<ApplicationIcon />}
          />,

          showCustomLeaseTemplate,

          <NavLinkItem
            to="/companies/rent_roll"
            key="/companies/rent_roll"
            primaryText={translateText('landlordPortal.sideBar.rentRoll')}
            leftIcon={<RentRollIcon />}
          />,

          <NavLinkItem
            to="/companies/tenants"
            key="/companies/tenants"
            primaryText={
              <span>
                <TenantResidentVerbiageHelper capitalize />s
              </span>
            }
            leftIcon={<AgentIcon />}
          />,

          <NavGroupItem
            key="/companies/maintenance"
            primaryText={translateText('landlordPortal.sideBar.maintenance')}
            leftIcon={<MaintenanceIcon />}
            links={maintenanceLinks}
          />,

          paymentsMenu,
          batchesLink,
          paymentsLink,

          <NavGroupItem
            key="/companies/community"
            primaryText={translateText('landlordPortal.sideBar.community')}
            leftIcon={<CommunityIcon />}
            links={communityLinks}
          />,

          <NavLinkItem
            to="/companies/properties"
            key="Properties"
            primaryText={translateText('landlordPortal.sideBar.properties')}
            leftIcon={<PropertiesIcon />}
          />,

          <NavLinkItem
            to="/companies/users"
            key="/companies/users"
            primaryText={translateText('landlordPortal.sideBar.users')}
            leftIcon={<AgentIcon />}
          />,

          templatesList,
          policiesLink,
          showMessagingLink,

          <NavGroupItem
            key="/companies/self_service_kiosk"
            primaryText={translateText('landlordPortal.sideBar.selfServiceKiosk')}
            links={selfServiceKioskLinks}
            leftIcon={<SelfServiceKioskIcon />}
          />,

          <NavGroupItem
            key="/companies/api_dashboard"
            primaryText={getTranslatedString('landlordPortal.sideBar.apiDashboard')}
            leftIcon={<APIDashboardIcon />}
            links={apiDashboardLinks}
          />,
        ];

        NavigationItems = compact(NavigationItems);

        let css = `
        .selected {
          border-color: ${AccentColor()} !important;
        }
        .mobile-menu {
          border-top: solid ${AccentColor()} 2px;
        }`;

        const headerVerbiage = this.props.maintenanceWorker
          ? 'pageTitle.maintenancePortal'
          : 'pageTitle.landlord';

        const isMobile = window.matchMedia('(max-width: 500px)').matches;
        const backgroundColor = showSplashBlackBorder && isMobile ? '#000' : '#eaecf1';

        return (
          <ContentProvider lang={lang} content={content}>
            <div style={{ height: '100%' }} ref="appContainer">
              <Helmet>
                <title>
                  {getCompanyName()} | {this.props.translate(headerVerbiage).props.children}
                </title>
                <link
                  rel="icon"
                  type="image/png"
                  href={customSquareImage || this.props.landlordLogoThumbUrl || '/blank.ico'}
                />
                <link
                  rel="apple-touch-icon"
                  type="image/png"
                  href={customSquareImage || this.props.landlordLogoThumbUrl || '/blank.ico'}
                />
              </Helmet>
              <Helmet
                meta={[
                  {
                    name: 'apple-mobile-web-app-title',
                    content: `${getCompanyName()} | ${
                      this.props.translate(headerVerbiage).props.children
                    }`,
                  },
                ]}
              />
              <style>{css}</style>
              <header>
                <MediaQuery query="(max-device-width: 750px)">
                  <LoadingBar
                    style={{
                      height: '4px',
                      zIndex: '5000',
                      backgroundColor: AccentColor(),
                    }}
                  />
                </MediaQuery>
                <MediaQuery query="(min-device-width: 751px)">
                  <LoadingBar
                    style={{
                      height: '2px',
                      zIndex: '5000',
                      backgroundColor: AccentColor(),
                    }}
                  />
                </MediaQuery>
              </header>
              <LoginDialog isOpen={this.props.showLoginDialog} />
              <NotificationSystem ref="notificationSystem" />
              <Measure
                onMeasure={(dimensions) => {
                  this.props.changeSignaturePageDimensions(dimensions.width, dimensions.height);
                  this._onResize(dimensions.width, dimensions.height);
                }}
              >
                <div style={{ width: '100%', height: '100%' }}>
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      right: '50%',
                      zIndex: 100000,
                    }}
                  >
                    <Confetti active={this.props.explosionCelebration} config={confettiConfig} />
                  </div>
                  <PayWall
                    active={this.props.active}
                    currentRoute={browserHistory.getCurrentLocation().pathname}
                  />
                  <PasswordExpiring
                    passwordExpirationDate={this.props.passwordExpirationDate}
                    changePasswordURL={this.props.changePasswordURL}
                    currentRoute={browserHistory.getCurrentLocation().pathname}
                    expiringDialogOpen={this.props.expiringDialogOpen}
                    hideExpiringPasswordDialog={this.props.hideExpiringPasswordDialog}
                  />

                  {this.props.showLoader && (
                    <div
                      style={{
                        position: 'relative',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: '500',
                      }}
                    >
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: '30px',
                          width: '60px',
                          margin: 'auto',
                        }}
                      >
                        <BounceLoader color={AccentColor()} />
                      </div>

                      <p
                        style={{
                          textAlign: 'center',
                          marginTop: '15px',
                          marginBottom: '15px',
                        }}
                      >
                        Bear with us as we {this.props.verbiage}.
                      </p>
                    </div>
                  )}
                  {!this.props.showPage &&
                    !this.props.showSignDocument &&
                    !this.props.showSplashScreenTemplate &&
                    !this.props.shouldShowNonAuthPage &&
                    !this.props.showApplicationForm &&
                    !this.props.showLoginForm &&
                    !this.props.showLoader && (
                      <div
                        style={{
                          position: 'relative',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: '500',
                        }}
                      >
                        <div
                          style={{
                            textAlign: 'center',
                            marginTop: '30px',
                            width: '60px',
                            margin: 'auto',
                          }}
                        >
                          <BounceLoader color={AccentColor()} />
                        </div>
                        <p
                          style={{
                            textAlign: 'center',
                            marginTop: '15px',
                            marginBottom: 0,
                          }}
                        >
                          Believe you can and you&rsquo;re halfway there.
                        </p>
                        <p
                          style={{
                            textAlign: 'center',
                            marginTop: '3px',
                            fontSize: '12px',
                          }}
                        >
                          -Theodore Roosevelt
                        </p>
                      </div>
                    )}

                  {this.props.showPage && !showSignDocument && !this.props.showLoader && (
                    <div style={{ height: '100%', width: '100%' }}>
                      {this.props.maintenanceWorker && (
                        <Sidebar
                          open={this.state.sidebarOpen}
                          docked={this.state.sidebarDocked}
                          onSetOpen={this.onSetSidebarOpen.bind(this)}
                          styles={{
                            overlay: { backgroundColor: 'rgba(0,0,0,0)' },
                            content: { overflowY: 'auto' },
                          }}
                          shadow={false}
                        >
                          <div className="body-container" style={{ height: '100%' }}>
                            <NavBar
                              dockSidebar={this.dockSidebar.bind(this)}
                              sidebarIsOpen={false}
                              logUserOut={this.props.logUserOut}
                              userType={this.props.userType}
                              helpDocuments={this.props.helpDocuments}
                              showSideBar={false}
                            />

                            {this.props.children}
                          </div>
                        </Sidebar>
                      )}
                      {this.props.agent && !this.props.maintenanceWorker && (
                        <Sidebar
                          sidebar={<SideBar>{NavigationItems}</SideBar>}
                          open={this.state.sidebarOpen}
                          docked={this.state.sidebarDocked}
                          onSetOpen={this.onSetSidebarOpen.bind(this)}
                          styles={{
                            overlay: { backgroundColor: 'rgba(0,0,0,0)' },
                            content: { overflowY: 'auto' },
                          }}
                          shadow={false}
                        >
                          <div className="body-container" style={{ height: '100%' }}>
                            <NavBar
                              dockSidebar={this.dockSidebar.bind(this)}
                              sidebarIsOpen={this.state.sidebarIsOpen}
                              logUserOut={this.props.logUserOut}
                              userType={this.props.userType}
                              helpDocuments={this.props.helpDocuments}
                              showSideBar={true}
                            />
                            <MediaQuery query="(max-device-width: 750px)">
                              <div
                                className="row"
                                style={{ marginBottom: 102 }}
                                id="mobile-menu-container"
                              >
                                <MobileMenu
                                  value={this.props.selectedRoute}
                                  onChange={this.handleChange}
                                >
                                  {NavigationItems}
                                </MobileMenu>
                              </div>
                            </MediaQuery>

                            {this.props.children}
                          </div>
                        </Sidebar>
                      )}
                    </div>
                  )}
                  {showSplashWithBackground && this.props.children}
                  {showSplashScreenTemplate && !this.props.showLoader && !isNewPath && (
                    <div
                      style={{
                        height: '100%',
                        width: '100%',
                        textAlign: 'center',
                        backgroundColor: backgroundColor,
                      }}
                      ref="appContainer"
                    >
                      <StyledDiv showBlackBorder={isMobile && showSplashBlackBorder}>
                        {showSplashBlackBorder && (
                          <StyledDivBlackBorder>
                            <LandlordLogo
                              fontSize="90px"
                              maxWidth="273px"
                              height="100px"
                              textHeight="70px"
                            />
                            {this.props.children}
                          </StyledDivBlackBorder>
                        )}
                        {showSplashCentered && (
                          <Fragment>
                            <LandlordLogo
                              fontSize="90px"
                              maxWidth="273px"
                              height="100px"
                              textHeight="70px"
                            />
                            {this.props.children}
                          </Fragment>
                        )}
                      </StyledDiv>
                    </div>
                  )}

                  {showSignDocument && (
                    <div style={{ height: '100%', width: '100%' }}>
                      <div className="body-container" style={{ height: '100%' }}>
                        <SignatureNavBar />
                        <div className="row" style={{ padding: '53px 0px 88px', height: '100%' }}>
                          {this.props.children}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Measure>
            </div>
          </ContentProvider>
        );
      }
    }
  )
);
